import { c as _c } from "react/compiler-runtime";
export default function ChevronLeft(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M20.03 27.99a.997.997 0 01-.549-.165c-4.194-2.755-8.312-6.302-11.909-10.259a2.362 2.362 0 010-3.152c3.594-3.956 7.712-7.504 11.91-10.26a1.001 1.001 0 011.097 1.671c-4.059 2.666-8.044 6.101-11.528 9.934a.358.358 0 00.001.461c3.485 3.835 7.471 7.27 11.527 9.933a1 1 0 01-.43 1.83l-.12.006z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}